import { type BoundActions, createActionsHook, type HookActionsFunction } from 'react-sweet-state';

import { type AgentModalStoreActions } from './AgentModalStoreActions';
import { type AgentModalStoreState, store } from './store';

export const useAgentsModalActions: HookActionsFunction<
	BoundActions<AgentModalStoreState, AgentModalStoreActions>
> = createActionsHook(store);
